export const GET_WHATSAPP_SUMMARY_SUCCESS = "GET_WHATSAPP_SUMMARY_SUCCESS";
export const GET_WHATSAPP_SUMMARY_REQUEST = "GET_WHATSAPP_SUMMARY_REQUEST";
export const GET_WHATSAPP_SUMMARY_FAILURE = "GET_WHATSAPP_SUMMARY_FAILURE";
export const getWhatsappSummarySuccess = (payload) => ({
    type: GET_WHATSAPP_SUMMARY_SUCCESS,
    payload,
});
export const getWhatsappSummaryRequest = () => ({
    type: GET_WHATSAPP_SUMMARY_REQUEST,
});
export const getWhatsappSummaryFailure = (payload) => ({
    type: GET_WHATSAPP_SUMMARY_FAILURE,
    payload,
});
